import * as React from "react";
import {FunctionComponent} from "react";
import {Divider, List, ListItem, ListItemIcon, ListItemText} from "@material-ui/core";
import "./sidebar-content.scss";
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import {Area} from "../../../repositories/area/Area";
import MapIcon from '@material-ui/icons/Map';
import PlaceIcon from '@material-ui/icons/Place';
import i18next from "../../../i18n/I18n";
import {TR} from "../../../i18n/TR";

interface SidebarContentProps {
    toggle: () => void,
    onAreaSelected: (area: Area) => void,
    areas: Area[],
    resetView: () => void
}

const SidebarContent: FunctionComponent<SidebarContentProps> = (
    {
        toggle,
        areas,
        onAreaSelected,
        resetView
    }
) => {
    return (
        <div
            className={'sidebar-content'}
            data-testid={'sidebar-content'}
        >
            <div className={'sidebar-content__uji-brand'}>
                <img
                    src={'uji-logo.png'}
                    className={'sidebar-content__uji-brand-img'}
                />
                <NavigateBeforeIcon
                    onClick={toggle}
                    data-testid={'sidebar-content__navigate-before-icon'}
                />
            </div>
            <Divider />

            <ListItem
                onClick={() => resetView()}
                button
            >
                <ListItemIcon>
                    <MapIcon/>
                </ListItemIcon>
                <ListItemText
                    primary={i18next.t(TR.TR_SEE_ALL_MAP)}
                    className={'sidebar-content__see-all-map'}
                />
            </ListItem>

            <Divider />
            <List className={'sidebar__content'}>
                {areas.map((area, index) => (
                    <ListItem
                        key={index}
                        onClick={() => onAreaSelected(area)}
                        button
                    >
                        <ListItemIcon>
                            <PlaceIcon/>
                        </ListItemIcon>
                        <ListItemText primary={area.name} />
                    </ListItem>
                ))}
            </List>
        </div>
    );
};

export default SidebarContent;
